import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'xp-field',
	standalone: true,
	imports: [CommonModule, MatTooltipModule],
	templateUrl: './xp-field.component.html',
	styleUrls: ['./xp-field.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpFieldComponent {
	label = input('');
	infoIconSrc = input('');
	infoTooltip = input('');
	errorText = input('');
	showError = input(false);
}
